var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.411,
    height: 36.743,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 463",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 895",
    d: "M23.287 3.121v30.5l-10.894-8.713H1.5V11.836h10.893z",
    strokeLinecap: "square",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 896",
    d: "M23.286 22.729a5.1 5.1 0 000-8.715",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 462",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 15",
    d: "M36.911 8.047v18.431"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    d: "M31.911 14.79v7.338"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 17",
    d: "M41.911 1.439v31.648"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    d: "M46.911 5.459v26"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 19",
    d: "M51.911 12.806v11.305"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 20",
    d: "M56.911 9.743v17.431"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 21",
    d: "M61.911 14.79v7.338"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadVoice);
export default __webpack_public_path__ + "static/media/downloadVoice.98b1ed12813d7380.svg";
export { ForwardRef as ReactComponent };